"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveDynamicValueBinding = void 0;
const resolveDynamicValueBindingCallback_1 = require("../calculations/resolveDynamicValueBindingCallback");
const resolveScopedBinding_1 = require("./resolveScopedBinding");
exports.resolveDynamicValueBinding = (0, resolveScopedBinding_1.resolveScopedBinding)(resolveDynamicValueBindingCallback_1.resolveDynamicValueBindingCallback);
//# sourceMappingURL=resolveDynamicValueBinding.js.map